var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new_user" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { attrs: { id: "content" } }, [
          _c(
            "div",
            [
              _c("dd-sitemap", {
                attrs: { pageKey: _vm.pageKey, pageList: _vm.pageList }
              }),
              _vm._v(" "),
              !_vm.isInviteUser
                ? _c("section", [
                    _c("h2", [_vm._v("お客様種別")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input_list user_type" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isUserType,
                              expression: "isUserType"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            id: "user_type_pri",
                            name: "usertype"
                          },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.isUserType, true)
                          },
                          on: {
                            click: _vm.changeUserType,
                            change: function($event) {
                              _vm.isUserType = true
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "radio-label bold",
                            attrs: { for: "user_type_pri" }
                          },
                          [_vm._v("個人")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isUserType,
                              expression: "isUserType"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            id: "user_type_corp",
                            name: "usertype"
                          },
                          domProps: {
                            value: false,
                            checked: _vm._q(_vm.isUserType, false)
                          },
                          on: {
                            click: _vm.changeUserType,
                            change: function($event) {
                              _vm.isUserType = false
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "radio-label bold",
                            attrs: { for: "user_type_corp" }
                          },
                          [_vm._v("法人")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isInviteUser
                ? _c("dd-corp", {
                    ref: "corpInputRef",
                    attrs: {
                      isManager: true,
                      isPrivateUser: _vm.isPrivateUser,
                      corpForm: _vm.corpForm
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("dd-user", {
                ref: "userInputRef",
                attrs: {
                  isEdit: false,
                  isPrivateUser: _vm.isPrivateUser && !_vm.isInviteUser,
                  userForm: _vm.userForm
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scroll_rule" },
                [_c("dd-user-rule-detial")],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { id: "consent" } }, [
                _c("ul", [
                  _c("li", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.consent,
                          expression: "userForm.consent"
                        }
                      ],
                      attrs: { type: "checkbox", id: "termsOfUse" },
                      domProps: {
                        checked: Array.isArray(_vm.userForm.consent)
                          ? _vm._i(_vm.userForm.consent, null) > -1
                          : _vm.userForm.consent
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.userForm.consent,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.userForm,
                                  "consent",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.userForm,
                                  "consent",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.userForm, "consent", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "termsOfUse" } }, [
                      _vm._v("利用規約に同意する。")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userForm.recvInfo,
                          expression: "userForm.recvInfo"
                        }
                      ],
                      attrs: { type: "checkbox", id: "mailMagazine" },
                      domProps: {
                        checked: Array.isArray(_vm.userForm.recvInfo)
                          ? _vm._i(_vm.userForm.recvInfo, null) > -1
                          : _vm.userForm.recvInfo
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.userForm.recvInfo,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.userForm,
                                  "recvInfo",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.userForm,
                                  "recvInfo",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.userForm, "recvInfo", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "mailMagazine" } }, [
                      _vm._v("メールマガジンを受け取る。")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    detail_btn: true,
                    btn_pos_center: true,
                    disabled: _vm.isDisabled
                  },
                  on: {
                    click: function($event) {
                      _vm.confirm()
                    }
                  }
                },
                [_vm._v("入力情報の確認 〉〉")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("お客様種別")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eab7986", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eab7986","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcRegistUserInput.vue
// module id = null
// module chunks = 